module.exports = __webpack_public_path__ + "img/hr-train-wheels-8.20a80a16.png";